// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2227) return "static/chunks/2227.543391d38fecd694.js";
	if (chunkId === 806) return "static/chunks/4163ae0c.936fd5f60daa8d3e.js";
	if (chunkId === 4001) return "static/chunks/4001.c93ab51cf6b59773.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"347":"643144ee","2366":"1d2671aa","4155":"0bd2f4cc"}[chunkId] || chunkId) + "-" + {"347":"f94e9a34ad8af6ba","2366":"1ecb7b02f938480e","4155":"37267324ffbe30d3","9138":"bb8052889546d232"}[chunkId] + ".js";
};